import {
  DashboardOutlined as DashboardOutlinedIcon,
  AssessmentOutlined as AssessmentOutlinedIcon,
  CableOutlined as CableOutlinedIcon,
  LocalGasStationOutlined as LocalGasStationOutlinedIcon,
  ReceiptLongOutlined as ReceiptLongOutlinedIcon,
  PeopleAltOutlined as PeopleAltOutlinedIcon,
  SecurityOutlined as SecurityOutlinedIcon,
  NotificationsActiveOutlined as NotificationsActiveOutlinedIcon,
  LocalFireDepartmentOutlined as LocalFireDepartmentOutlinedIcon,
  AccessTimeOutlined as AccessTimeOutlinedIcon, // 👈 Employee Shift icon
} from "@mui/icons-material";

import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

export default function Navbar({ menus }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Map menu names to routes
  const menuRoutes = {
    Dashboard: "/dashboard",
    Reports: "/reports",
    "Pump Port": "/pump-port",
    Pump: "/pump",
    "Pump Transaction": "/pump-transaction",
    "User Management": "/user-management",
    "Role Management": "/role-management",
    Alert: "/alert",
    Fuel: "/fuel",
    "Employee Shift": "/employee-shift",
  };

  // Map menu names to icons
  const menuIcons = {
    Dashboard: <DashboardOutlinedIcon />,
    Reports: <AssessmentOutlinedIcon />,
    "Pump Port": <CableOutlinedIcon />,
    Pump: <LocalGasStationOutlinedIcon />,
    "Pump Transaction": <ReceiptLongOutlinedIcon />,
    "User Management": <PeopleAltOutlinedIcon />,
    "Role Management": <SecurityOutlinedIcon />,
    Alert: <NotificationsActiveOutlinedIcon />,
    Fuel: <LocalFireDepartmentOutlinedIcon />,
    "Employee Shift": <AccessTimeOutlinedIcon />,
  };

  return (
    <List>
      {menus.map((menu) => {
        const route = menuRoutes[menu] || "/dashboard";
        const selected =
          menu === "Dashboard"
            ? location.pathname === "/dashboard" || location.pathname === "/"
            : location.pathname === route;

        return (
          <ListItem key={menu} disablePadding>
            <ListItemButton
              onClick={() => navigate(route)}
              selected={selected}
              sx={{
                "&.Mui-selected": {
                  bgcolor: "#1565c0",
                  color: "white",
                },
                "&.Mui-selected:hover": {
                  bgcolor: "#0d47a1",
                },
                "&:hover": {
                  bgcolor: "rgba(21,101,192,0.1)",
                },
                py: 1.2, // compact height
              }}
            >
              <ListItemIcon sx={{ color: "inherit", minWidth: 40 }}>
                {menuIcons[menu] || <DashboardOutlinedIcon />}
              </ListItemIcon>
              <ListItemText
                primary={menu}
                primaryTypographyProps={{
                  fontSize: 14,
                  fontWeight: selected ? 600 : 400,
                }}
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
}
